import type { FaireProductEntity } from "../../entity_types/product";

export const p_rqg8xkbkwg: FaireProductEntity = {
  token: "p_rqg8xkbkwg",
  type: "product",
  name: "Bitch Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/92fa1790343e290250af99b43d5eb95f23ce31dff30bb064080996ea6a82c6ae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/16ecabfaa5ce12229b0254cbce5a494c39a708f445b8ebfb60ca0644b1ce5a1c.jpeg",
    "https://cdn.faire.com/fastly/d3af49e3fea75191082a3d15821cd3a73d3cfbe5f4f1620620c065df0af4f0a7.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/f415a2cb8c37828b00d604ac821a90ec065f4bd50e18160ad36cba64d39bbf74.jpeg",
    "https://cdn.faire.com/fastly/9a0749010fbe172f9caf3dfcea3c919ede2a40381694534a1303aab0858323b7.jpeg",
    "https://cdn.faire.com/fastly/2f4a43a6ec278fc7d6537306716744e6b48cdccea91ea9565098c85343b907c0.jpeg",
    "https://cdn.faire.com/fastly/ef19cbc5c1e5094f6b4ab5f759e6a50c0933cd65fbd423008eefc82af82146ac.jpeg",
    "https://cdn.faire.com/fastly/c84d3337734a2c7c3e376ec534c53c3e194d45eb1dd0daeb9d49cedc3dcef5a3.jpeg"
  ],
  priceDollars: 6.75,
  description: "Sometimes all it takes is a single word to let the world know what's up. These socks are the perfect accent to any outfit for all you lovely bitches out there. 💜\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:20.445Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
